import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { Valores } from '../../comun/models/valores.model';
import { MuroFiltrosService } from '../../comun/services/muro-filtros.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-muro-filtros',
  templateUrl: './muro-filtros.component.html',
  styleUrl: './muro-filtros.component.css'
})
export class MuroFiltrosComponent {
  @Input() userid: Number = 0;
  @Input() tipo: string = 'RS';
  @Input('tipo_id') tipoId: number = 0;
  @Input() paseosEstado: 'todos' | 'proximos' | 'finalizados' = 'todos';
  @Input() ordenPublicaciones: 'recientes' | 'actividad' = 'recientes';
  @Output() paseosEstadoChange = new EventEmitter<'todos' | 'proximos' | 'finalizados'>();
  @Output() ordenPublicacionesChange = new EventEmitter<'recientes' | 'actividad'>();
  tipopublicaciones: Valores[] = [];
  desplegableAbierto = false;

  constructor(public query: QueryService, private muroFiltrosService: MuroFiltrosService) { }

  ngOnInit() {
    this.getTipoPublicaciones();
  }

  getTipoPublicaciones() {
    this.query.query('valores', 'GET', { grupo: 'PUBLICACION'}).subscribe((resultado:any) => {
      this.tipopublicaciones = resultado.registros;      
      this.muroFiltrosService.setValores(this.tipopublicaciones);
      //this.getNumeroPublicaciones();
    });
  }

  seleccionarTipo(tipo: any) {
    tipo.activo = !tipo.activo;
    this.muroFiltrosService.setValores(this.tipopublicaciones);
  }

  cambiarEstadoPaseos(estado: 'todos' | 'proximos' | 'finalizados'): void {
    if (estado !== this.paseosEstado) this.paseosEstadoChange.emit(estado);
  }

  cambiarOrden(orden: 'recientes' | 'actividad'): void {
    if (orden !== this.ordenPublicaciones) this.ordenPublicacionesChange.emit(orden);
  }

  limpiarFiltros(): void {
    let cambiados = false;
    this.tipopublicaciones.forEach(tipo => {
      if (tipo.activo) {
        tipo.activo = false;
        cambiados = true;
      }
    });
    if (cambiados) this.muroFiltrosService.setValores(this.tipopublicaciones);
    this.cambiarEstadoPaseos('todos');
    this.cambiarOrden('recientes');
  }

  get seleccionadosCount(): number {
    return this.tipopublicaciones.filter(t => !!t.activo).length;
  }

  quitarTipos(): void {
    if (!this.seleccionadosCount) return;
    this.tipopublicaciones.forEach(t => t.activo = false);
    this.muroFiltrosService.setValores(this.tipopublicaciones);
  }

  get hayFiltrosActivos(): boolean {
    return this.tipopublicaciones.some(t => !!t.activo) ||
      this.paseosEstado !== 'todos' ||
      this.ordenPublicaciones !== 'recientes';
  }

  getNumeroPublicaciones() {
    this.query.query('muros', 'NUMERO_PUBLICACIONES', { ID: this.userid, tipo: this.tipo, tipo_id: this.tipoId }).subscribe((resultado:any) => {
      const numeroPublicaciones = resultado.registros;
      // Asignar el número de publicaciones a cada tipo de publicación
      this.tipopublicaciones.forEach(tipo => {
        tipo.numero = numeroPublicaciones.find((item: any) => item.rs_tipo_publicacion === tipo.va_id)?.numero || 0;
        //this.muroFiltrosService.setValores(this.tipopublicaciones);
      });
    });
  }

  get numeroFiltrosActivos(): number {
    return this.seleccionadosCount +
      (this.paseosEstado !== 'todos' ? 1 : 0) +
      (this.ordenPublicaciones !== 'recientes' ? 1 : 0);
  }

  get resumenFiltros(): string {
    if (!this.hayFiltrosActivos) return 'Todas las publicaciones';
    const partes: string[] = [];
    if (this.seleccionadosCount === 1) {
      const tipo = this.tipopublicaciones.find(t => !!t.activo);
      if (tipo) partes.push(tipo.va_nombre);
    } else if (this.seleccionadosCount > 1) {
      partes.push(`${this.seleccionadosCount} tipos`);
    }
    if (this.paseosEstado === 'proximos') partes.push('Paseos próximos');
    if (this.paseosEstado === 'finalizados') partes.push('Paseos finalizados');
    if (this.ordenPublicaciones === 'actividad') partes.push('Actividad reciente');
    return partes.join(' · ');
  }

  get textoBoton(): string {
    const seleccionados = this.tipopublicaciones.filter(t => t.activo);

    if (seleccionados.length === 0 || seleccionados.length === this.tipopublicaciones.length) {
      return 'Todos';
    }
    if (seleccionados.length === 1) {
      return seleccionados[0].va_nombre;
    }
    return `${seleccionados.length} filtros seleccionados`;
  }
}
